import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SecondHeader from '../Layout/SecondHeader';
import SecondFooter from '../Layout/SecondFooter';
import AssessmentModal from '../Modal/AssessmentModal';
import './programs.css';

export default function Programs() {
  const [assessmentShow, setAssessmentShow] = useState(false);

  const buildProgramLink = (programLabel) =>
    `/cancer-recovery-management-online?program=${encodeURIComponent(programLabel)}#regForm`;

  return (
    <div className="programs-page">
      <SecondHeader />
      <AssessmentModal show={assessmentShow} onHide={() => setAssessmentShow(false)} />

      <section className="prog-hero">
        <div className="container">
          <h1 className="prog-hero-title">
            Programs designed to support you -{' '}
            <span className="prog-hero-sub">wherever you are in your journey</span>
          </h1>
        </div>
      </section>

      <section className="prog-intro">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <p>
                With more than 20 years of experience in health, recovery, clinical practice, and
                education, we have developed a structured and comprehensive system to support
                individuals facing cancer - before, during, and after treatment.
              </p>
              <p>
                Our programs are built on one principle: giving you clarity, guidance, and the right
                tools to take an active role in your health.
              </p>
              <p>
                Research shows that a significant proportion of cancer cases are influenced by
                lifestyle and early intervention. This means that informed choices, consistent
                support, and the right actions can make a meaningful difference.
              </p>
              <p>
                Whether your goal is prevention, support during treatment, or recovery, our programs
                are designed to meet you at your current stage - with the level of support you need.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="prog-cards-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <p className="prog-choose-label text-center">
                Choose the level of support and program that fits your needs.
              </p>
            </div>
          </div>
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-4 col-md-12 d-flex">
              <div className="prog-card w-100">
                <h3 className="prog-card-name">Fully Digital Program 12-Months</h3>
                <div className="prog-card-price">1,200 USD</div>
                <p className="prog-card-desc prog-card-emphasis">
                  A complete 12-month digital recovery program for individuals who want clear
                  structure, trusted guidance, and the freedom to work at their own pace.
                </p>
                <p className="prog-card-desc prog-card-emphasis">
                  You receive access to our online progress platform, developed over many years to
                  help individuals improve health, energy, strength, mindset, and daily direction.
                </p>
                <p className="prog-card-desc prog-card-emphasis">
                  The program includes guidance across 10 key recovery areas, including:
                </p>
                <ul className="prog-card-list">
                  <li>Physical health and progress tracking</li>
                  <li>Energy and fatigue management</li>
                  <li>Nutrition, vitamins and minerals</li>
                  <li>Strength and movement</li>
                  <li>Mental wellbeing and emotional balance</li>
                  <li>Stress reduction and motivation</li>
                  <li>Long-term health foundations</li>
                </ul>
                <p className="prog-card-suited prog-card-emphasis">
                  Designed for individuals who are ready to take ownership of their process while
                  following a clear and proven framework.
                </p>
                <div className="prog-card-actions">
                  <Link
                    to={buildProgramLink("Fully Digital Program 12-Months")}
                    className="prog-card-register-btn"
                  >
                    Register Now
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-12 d-flex">
              <div className="prog-card prog-card-featured w-100">
                <h3 className="prog-card-name">Digital Program + Health Advisor 12-Months</h3>
                <div className="prog-card-price">4,900 USD</div>
                <p className="prog-card-desc">
                  Includes full access to the complete 12-month digital program, plus personal
                  email support and ongoing guidance from a dedicated Health Advisor.
                </p>
                <p className="prog-card-desc">
                  Included are 12 one-to-one online sessions (30 minutes each), providing a more
                  supported and responsive process with individual feedback and follow-up
                  throughout the year.
                </p>
                <p className="prog-card-suited">
                  <em>
                    Particularly valuable for individuals facing more complex situations, or for
                    those who value continuity, accountability, and tailored support over time.
                  </em>
                </p>
                <div className="prog-card-actions">
                  <Link
                    to={buildProgramLink("Digital Program + Health Advisor 12-Months")}
                    className="prog-card-register-btn"
                  >
                    Register Now
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-12 d-flex">
              <div className="prog-card prog-card-platinum w-100 d-flex flex-column">
                <h3 className="prog-card-name" style={{ color: '#fff' }}>
                  The Cayman Recovery Experience
                </h3>
                <div className="prog-card-price" style={{ color: '#b8e06a' }}>
                  Program Fee: USD 29,000
                </div>
                <p className="prog-card-desc" style={{ color: 'rgba(255,255,255,0.82)' }}>
                  A Private Five-Day Recovery Intensive
                </p>
                <p className="prog-card-desc" style={{ color: 'rgba(255,255,255,0.82)' }}>
                  Designed for individuals who value the highest level of personal attention,
                  discretion, and professional guidance, The Cayman Recovery Experience offers an
                  exclusive and highly personalized recovery planning service.
                </p>
                <p className="prog-card-desc" style={{ color: 'rgba(255,255,255,0.82)' }}>
                  The Cayman Islands have been selected for their unique combination of privacy,
                  tranquility, year-round tropical climate, and access to high-quality health and
                  wellness services.
                </p>
                <div className="prog-card-actions">
                  <a href="#cayman-details" className="prog-card-register-btn prog-card-register-btn-light">
                    Read More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="prog-platinum-section" id="cayman-details">
        <div className="container">
          <div className="prog-platinum-inner">
            <p className="prog-platinum-label">Premium | Highly Personalised</p>
            <h2 className="prog-platinum-title">The Cayman Recovery Experience</h2>
            <p className="prog-platinum-price">Program Fee: USD 29,000</p>

            <p className="prog-platinum-desc">
              Designed for individuals who value exceptional personal attention, privacy, and
              professional guidance, The Cayman Recovery Experience is an exclusive five-day
              recovery intensive created to provide clarity, direction, and a highly personalized
              recovery strategy.
            </p>
            <p className="prog-platinum-desc">
              This experience is intended for those who want more than general advice. It is for
              individuals seeking a structured, comprehensive, and practical approach built
              specifically around their own health, circumstances, priorities, and long-term goals.
            </p>
            <p className="prog-platinum-desc">
              The process begins with developing a detailed understanding of your current
              situation. Through extensive health and lifestyle assessments, together with in-depth
              one-to-one consultations, we identify the areas that have the greatest potential to
              influence your overall recovery and well-being.
            </p>
            <p className="prog-platinum-feature-title">Your Dedicated Recovery Specialist</p>
            <p className="prog-platinum-desc">
              Based on these findings, your dedicated Recovery Specialist develops a comprehensive
              recovery strategy designed exclusively for you. Every recommendation is carefully
              selected to be relevant, realistic, and sustainable, creating a clear roadmap that
              can be implemented with confidence long after your stay in the Cayman Islands.
            </p>
            <p className="prog-platinum-desc">
              Throughout the five-day intensive, you will work closely with your dedicated
              Recovery Specialist during private daily consultations. Together, you will translate
              knowledge into practical action, establish priorities, and create an implementation
              plan that supports measurable progress over the coming months.
            </p>
            <p className="prog-platinum-desc">
              The Cayman Islands have been selected for their unique combination of discretion,
              tranquility, year-round tropical climate, and access to high-quality health and
              wellness services. Away from everyday demands, the setting provides an ideal
              environment for focused reflection, learning, and planning.
            </p>

            <p className="prog-platinum-feature-title">Your Recovery Experience Includes</p>
            <ul className="prog-platinum-list">
              <li>Comprehensive health and lifestyle assessments</li>
              <li>In-depth review of your current situation and recovery priorities</li>
              <li>A fully personalized recovery strategy</li>
              <li>Intensive daily one-to-one consultations</li>
              <li>Practical implementation and progression planning</li>
              <li>Individual nutrition, lifestyle, and self-management guidance</li>
              <li>Personalized daily action plans</li>
              <li>Twelve months of structured follow-up and ongoing support</li>
            </ul>

            <p className="prog-platinum-desc" style={{ marginTop: '20px' }}>
              This is not a standardized program or a quick solution. It is a professional
              collaboration built on careful assessment, clinical experience, and individualized
              planning.
            </p>
            <p className="prog-platinum-desc">
              Many participants come to us after being told that no further curative treatment
              options remain, or that their treatment possibilities are limited. While every
              individual and every diagnosis is different, experience shows that people often
              possess greater capacity for improvement than initially expected.
            </p>
            <p className="prog-platinum-desc">
              Our role is not to predict outcomes, but to help you maximize your individual
              potential by focusing on the factors that can be influenced. We combine structure,
              scientific knowledge, practical experience, and continuous guidance to help you make
              meaningful and sustainable progress.
            </p>
            <p className="prog-platinum-desc">
              Unlike standardized wellness retreats or medical tourism programs, The Cayman
              Recovery Experience is limited to one participant at a time, allowing your dedicated
              Recovery Specialist to focus exclusively on your individual recovery throughout the
              entire five-day intensive.
            </p>

            <p className="prog-platinum-feature-title" style={{ marginTop: '28px' }}>
              Program Fee: USD 29,000 includes:
            </p>
            <ul className="prog-platinum-list">
              <li>Five nights&apos; accommodation in a private villa</li>
              <li>Daily breakfast, lunch, and dinner</li>
              <li>Comprehensive health and lifestyle assessments</li>
              <li>Intensive one-to-one consultations throughout your stay</li>
              <li>A fully personalized recovery strategy</li>
              <li>Individual implementation and progression planning</li>
              <li>Personalized nutrition, lifestyle, and self-management guidance</li>
              <li>Practical tools and daily action plans</li>
              <li>Twelve months of structured follow-up and progress reviews</li>
              <li>
                Access to your dedicated Recovery Specialist throughout your 12-month recovery
                program
              </li>
            </ul>
            <p className="prog-platinum-desc" style={{ marginTop: '20px' }}>
              <strong>Not included:</strong> International flights, medical treatments, and
              third-party healthcare or wellness services.
            </p>
            <p className="prog-platinum-desc">
              Please note: The Cayman Recovery Experience is available by application only. Each
              application is carefully reviewed to ensure that every participant receives the
              highest possible level of personalized attention and professional support.
            </p>
          </div>
        </div>
      </section>

      <section className="prog-single-cta">
        <div className="container text-center">
          <p className="prog-cta-label">Ready to take the next step?</p>
          <p className="prog-cta-note">
            Each case is reviewed individually. If appropriate, a private consultation will be arranged.
          </p>
          <button className="prog-apply-btn" onClick={() => setAssessmentShow(true)}>
            Begin Confidential Assessment
          </button>
        </div>
      </section>

      <SecondFooter />
    </div>
  );
}
